import React from "react";
import PropTypes from "prop-types";

const WorkFilter = ({ categories, classOption, activeFilter, setActiveFilter }) => {

    // Simple function to format slug for display
    const formatCategoryName = (slug) => {
        if (slug === 'all') return 'All';
        return slug
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div className={`messonry-button ${classOption}`}>
            {categories.map((cat, idx) => (
                <button
                    key={idx}
                    className={`${activeFilter === cat ? "is-checked" : ""}`}
                    onClick={() => setActiveFilter(cat)}
                >
                    <span className="filter-text">{formatCategoryName(cat)}</span>
                </button>
            ))}
        </div>
    );
};

WorkFilter.propTypes = {
    categories: PropTypes.array.isRequired,
    classOption: PropTypes.string,
    activeFilter: PropTypes.string.isRequired,
    setActiveFilter: PropTypes.func.isRequired,
};

WorkFilter.defaultProps = {
    classOption: "text-lg-right text-left mb-lg-13 mb-md-13 mb-6",
};

export default WorkFilter;
